import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { featureToggleGuard } from 'ish-core/feature-toggle.module';

const routes: Routes = [
  {
    path: 'custom-quickorder',
    loadChildren: () =>
      import('./custom-quickorder/custom-quickorder-page.module').then(m => m.CustomQuickorderPageModule),
    canActivate: [featureToggleGuard],
    data: { feature: 'customQuickorder', breadcrumbData: [{ key: 'quickorder.page.breadcrumb' }] },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomQuickorderRoutingModule {}
